export default __webpack_public_path__ + "static/media/049-newborn.449f0cbf.png";